export { BodyIcon } from "./body";
